import React from 'react';

export default function OverviewIcon({ name }) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    {name === 'campaigns' ? <path d="m3 11 18-8-8 18-2-8-8-2Zm8 2 10-10" />
      : name === 'mail' ? <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>
        : name === 'click' ? <path d="m5 3 14 10-7 1-3 7-4-18Zm7 11 5 7" />
          : name === 'form' ? <><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 7h6M9 11h6m-7 5 2 2 5-5" /></>
            : name === 'plus' ? <path d="M12 5v14M5 12h14" />
              : name === 'refresh' ? <path d="M20 7v5h-5M4 17v-5h5m-5 0a8 8 0 0 1 14-5l2 2m0 3a8 8 0 0 1-14 5l-2-2" />
                : name === 'warning' ? <path d="m12 3 10 18H2L12 3Zm0 6v5m0 3h.01" />
                  : <path d="M4 12h15m-6-6 6 6-6 6" />}
  </svg>;
}
